import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { config } from 'services/config';
import type { StudyView, ViewParams, TrackViewParams } from '@/models/view';
import { Pagination } from '@/models';
import { buildQueryString, prepareHeaders } from '@/state/slices/index';

export const ViewsAPI = createApi({
  reducerPath: 'viewsAPI',
  baseQuery: fetchBaseQuery({
    baseUrl: config.BASE_URL,
    prepareHeaders,
  }),
  tagTypes: ['View'],
  endpoints: (builder) => ({
    getViews: builder.query<Pagination<StudyView>, ViewParams>({
      query: (params) => {
        const queryString = buildQueryString(params as Record<string, string>);
        return {
          url: `/views/${queryString}`,
          method: 'GET',
        };
      },
      providesTags: (result) =>
        result
          ? [
              { type: 'View', id: 'LIST' },
              ...result.results.map((v) => ({
                type: 'View' as const,
                id: v.uuid,
              })),
            ]
          : [{ type: 'View', id: 'LIST' }],
    }),
    trackView: builder.mutation<void, TrackViewParams>({
      query: (body) => ({
        url: '/views/',
        method: 'POST',
        body,
      }),
      invalidatesTags: [{ type: 'View', id: 'LIST' }],
    }),
  }),
});

export const { useGetViewsQuery, useTrackViewMutation } = ViewsAPI;
